var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-173 -767) translate(105 119) translate(24 640) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173 -767) translate(105 119) translate(24 640) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.037 15.022h-1.975v1.956h1.975v-1.956zm3.95 0h-1.975v1.956h1.976v-1.956zm3.951 0h-1.975v1.956h1.975v-1.956zm1.976-6.844h-.988V6.222H19.95v1.956h-7.902V6.222h-1.975v1.956h-.988c-1.096 0-1.965.88-1.965 1.955l-.01 13.69c0 1.075.88 1.955 1.975 1.955h13.828c1.086 0 1.975-.88 1.975-1.956V10.133c0-1.075-.889-1.955-1.975-1.955zm0 15.644H9.086V13.067h13.828v10.755z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.bc03dc2777b2d228145b1b4cfea35b0a.svg";
export { ForwardRef as ReactComponent };